export interface SymbolInfoCapsuleConfigState {
    symbol?: string;
}

export const initialSymbolInfoCapsuleConfigState: SymbolInfoCapsuleConfigState =
    {};
